<div class="confirm-dialog-overlay" *ngIf="isVisible" (click)="onBackdropClick($event)">
  <div class="confirm-dialog" (click)="onModalClick($event)">
    <!-- Dialog Header -->
    <div class="dialog-header">
      <h3 class="dialog-title">{{ title }}</h3>
      <button type="button" class="close-btn" (click)="onClose()" aria-label="Close">
        <span aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
            <path d="M0.183059 1.06694C-0.0610195 0.822864 -0.0610195 0.427136 0.183059 0.183058C0.427136 -0.0610194 0.822865 -0.0610194 1.06694 0.183058L7.5 6.61612L13.9331 0.183058C14.1771 -0.0610194 14.5729 -0.0610194 14.8169 0.183058C15.061 0.427136 15.061 0.822864 14.8169 1.06694L8.38388 7.5L14.8169 13.9331C15.061 14.1771 15.061 14.5729 14.8169 14.8169C14.5729 15.061 14.1771 15.061 13.9331 14.8169L7.5 8.38389L1.06694 14.8169C0.822865 15.061 0.427137 15.061 0.183059 14.8169C-0.0610187 14.5729 -0.0610187 14.1771 0.183059 13.9331L6.61612 7.5L0.183059 1.06694Z" fill="black"/>
          </svg>
        </span>
      </button>
    </div>

    <!-- Dialog Body -->
    <div class="dialog-body">
      <p class="dialog-message">{{ message }}</p>
    </div>

    <!-- Dialog Footer -->
    <div class="dialog-footer">
      <button type="button" 
              class="btn {{ cancelButtonClass }}" 
              (click)="onCancel()">
        {{ cancelText }}
      </button>
      <button type="button" 
              class="btn {{ confirmButtonClass }}" 
              (click)="onConfirm()">
        {{ confirmText }}
      </button>
    </div>
  </div>
</div> 